require('../../modules/es6.array.find-index');
module.exports = require('../../modules/_core').Array.findIndex;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/find-index.js
// module id = 195
// module chunks = 10